import {Link, useLoaderData, useRouteLoaderData} from '@remix-run/react'
import React, {Fragment} from 'react'
import clsx from 'clsx'
import {slugToText} from '@roundforest/text-transforms-commons'
import {getDomainConfig} from '~/domains'
import type {CategoriesDataProps, RootLoaderResponse} from '~/types'
import {getTranslation} from '~/localization/translation'
import {IconRightArrowLightWeight} from '~/icons/home-page/brg-icon-app-logo-thick'
import {useReportWidgetClick, useReportWidgetSeen} from '~/hooks/analytic-hooks'

const DealsLists = () => {
  const {language, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const {newHomePageData} = useLoaderData() as CategoriesDataProps

  const translations = getTranslation(language)
  const {styles: stylesBydomain} = getDomainConfig(domain, locale)
  const listsWithDeals = newHomePageData?.homepageData?.listsWithDeals

  const [widgetRef] = useReportWidgetSeen({
    widget_name: 'deals-lists',
    widget_place: 'middle',
  })
  const reportWidgetClick = useReportWidgetClick()

  const displayItems = listsWithDeals && listsWithDeals?.length > 1

  return (
    displayItems && (
      <div
        className={clsx('mx-auto flex flex-col gap-4', stylesBydomain.UTILS_MAIN_CONTAINER, 'utils_main_container')}
        ref={widgetRef}
      >
        <h3 className="text-center text-xl font-bold">{translations.Home.DealsLists.title}</h3>
        <div className="flex flex-row justify-between gap-6 mobile:flex-col">
          {listsWithDeals?.slice(0, 3)?.map(({slug, image, totalDiscountedProducts}, i) => {
            const categoryName = slugToText(slug)
            return (
              <Fragment key={`${i}-${slug}`}>
                <Link
                  to={`/${slug}`}
                  aria-label={`view ${slug}`}
                  prefetch="intent"
                  onClick={() =>
                    reportWidgetClick({
                      widget_name: 'category-deals-lists',
                      widget_place: 'grid-item',
                      trigger_type: categoryName,
                    })
                  }
                  className="flex min-h-52 w-full max-w-80 flex-col gap-2 rounded-lg bg-[#F5F5F5] p-3 mobile:min-h-32 mobile:max-w-full mobile:flex-row"
                >
                  <div className="flex h-[105px] items-center justify-center bg-white p-2 mobile:h-full mobile:w-[138px]">
                    <img src={image} alt={slug} className="size-24 object-scale-down" loading="lazy" />
                  </div>
                  <div className="flex flex-col justify-center gap-2">
                    <span className="text-base font-bold capitalize">{categoryName}</span>
                    {totalDiscountedProducts && totalDiscountedProducts > 0 ? (
                      <div
                        className={clsx(
                          'h-fit w-fit rounded-full px-2.5 text-base font-light text-white',
                          stylesBydomain.HOMEPAGE_ON_SALE_CTA,
                        )}
                      >
                        {translations.Home.DealsLists.onSale(totalDiscountedProducts)}
                      </div>
                    ) : null}
                    <div className="relative flex flex-row gap-2 text-[13px] font-light text-[#494747] underline">
                      {translations.Home.viewAll} <IconRightArrowLightWeight className="h-5 w-5" />
                    </div>
                  </div>
                </Link>
              </Fragment>
            )
          })}
        </div>
      </div>
    )
  )
}

export default DealsLists
